import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { SessionStorageService } from 'app/shared/services/session-storage.service';
import { environment } from 'environments/environment';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
@Component({
  selector: 'app-tickets-list',
  templateUrl: './tickets-list.component.html',
  styleUrls: ['./tickets-list.component.scss',
    "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class TicketsListComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  searchByName: ''
  myForm : FormGroup
  searchVal = null
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = ''
  isFilter: boolean = false
  // column header
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Designation", prop: "designation" },
    { name: "Phone", prop: "phone" },
    { name: "Actions", prop: "actions" },
  ];

  // private
  private tempData = [];
  imageUrl = environment.apiUrls.imageUrl;
  user_role: any
  statusList = []
  activeTab =''
  employee_id:any
  isActivated:boolean
  task_status_list=[];
  task_status_cat_id ='643e806559b78b65557d7456'

  @ViewChild('name') inputName;
  selected_type=null
  user_id:any
  total_salary:any
  employee_type: any
  employee_type_id =''
  public empTypeView: boolean[] = [];
  empList = []
  task_priority_catId = '643e7faf59b78b65557d744e'
  task_priority_List = []
  isReadOnly : boolean = false;
  update_row_data: any
  row_id: any
  row_prop: any
  today_date: any
  isEditor: boolean = false
  task_stage_cat_id ='64ae4427e0a6ff2e7db7830e'
  task_stage_list = []
  stage_list = []
  
    isDropdownOpen: boolean = false
    isDropdownOpen_student: boolean = false
    isDropdownOpen_employee: boolean = false
    isEmpList: boolean = false
    isTeamList: boolean = false
    isStudentList: boolean = false
    isBatchList: boolean = false
    isScheduleList: boolean = false
    isPriorityList: boolean = false
    isType: boolean = false
    isTaskLabel: boolean = false
    isTime: boolean = false
    isBudget: boolean = false
    isDueDate: boolean = false
    isMandatory: boolean = false
    isEmployee: boolean = false
    isStudent: boolean = false
    isProjectList: boolean = false
    isCheckList: boolean = false
    isLeadType: boolean = false
    isTrainingLead: boolean = false
    isOutsourceLead: boolean = false
    isTeam_selected_list: boolean = false
  isBatch_selected_list: boolean = false
  
    team_selected_list = []
  team_selected_list_data: string[] = [];
  batch_selected_list = []
  batch_selected_list_data: string[] = [];
  teamList = []
  studentList = []
  batchList = []
  selectTeam: string[] = [];
  selectedEmp: string[] = [];
  selectedStudent: string[] = [];
  selectedBatch: string[] = [];
  selectedSchedule = null
  selectedMandatory = null
  selectedTaskLabel = null
  selectedType = null
  teamId = "631ad9d8ce5c666542591bee"

  isAllSelected = false;
  
  task_for_selected = null
  current_date: any
  time: any
  budget_val: any

   scheduleList = [
    { name: 'One Time', id: 'oneTime' },
    { name: 'Twice in a day', id: 'twice_in_a_day' },
    { name: 'Once in a day', id: 'once_in_a_day' },
    { name: 'Weekly', id: 'weekly' },
    { name: 'Bi-Weekly', id: 'bi_weekly' },
    { name: 'Monthly', id: 'monthly' },
    { name: 'Half-Yearly', id: 'half_yearly' },
    { name: 'Yearly', id: 'yearly' }

  ]

   mandatoryList = [
    { name: 'No', id: 'no' },
    { name: 'Yes', id: 'yes' },
  ]
  typeList = [
    { name: 'Ticket', id: 'ticket' },
    { name: 'Projects', id: 'projects' },
    { name: 'Leads', id: 'leads' },
    { name: 'Checklist', id: 'checklist' },
    { name: 'Message', id: 'message' }
  ]
  taskLabelList = []

  leads_type = [
    { name: 'Training', id: 'training' },
    { name: 'Outsource', id: 'outsource' },
  ]
  select_leadType = null

  task_label_catId = '643e7f6f59b78b65557d744a'

  selectedItemCount: number = 0;

  project_list = []
  select_project: string[] = [];
  check_list = []
  select_checklist: string[] = [];
  training_list = []
  outsource_list = []
  select_training_lead = null
  select_outsource_lead = null
  taskDetail: any
  taskId: any
  selected_task_priority = '643e823159b78b65557d74ab'

   task_model={
          type_checklist: [],
          to: [],
          title: '',
          body: '',
          due_date: '',
          priority: '',
          label: [],
          is_schedule: '',
          scheduleduration: '',
          is_mandatory: '',
          working_hours: '',
          budget: '',
          stage: '',
          status: '',
          notes: '',
          admin_notes: ''
   }
      selected_task_label = null
      task_id:any
   isAddNewTask : boolean =false

  guideline_data:any

  constructor(public apiService: ApiService,
    public toastr: ToastrService,
    private modalService: NgbModal,
    private session: SessionStorageService,
    private spinner: NgxSpinnerService,private activerouter: ActivatedRoute,
    private route: Router,private formBuilder: FormBuilder) {
    this.user_role = JSON.parse(localStorage.getItem('user'))
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))   
    let key_data = setting_data.filter((item) => item.key == 'Tickets')
    this.guideline_data = key_data[0]?._id
    this.getTaskStageList()
    this.selectedType = 'ticket'
    this.selectedSchedule = 'oneTime'
    this.selectedMandatory = 'no'
    this.current_date = this.getCurrentDate()
    this.time = 1
    this.budget_val = 0

  }

  ngOnInit(): void {
    let date = new Date()
    this.today_date = moment(date).format();

     document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isDropdownOpen = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isDropdownOpen_student = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isDropdownOpen_employee = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isScheduleList = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isPriorityList = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isTaskLabel = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isMandatory = false;
      }
    });
    this.isEmployee = true;
    this.isEmpList = true;
    this.task_for_selected = 'employee'
    this.myForm = this.formBuilder.group({
      title: ['', Validators.required],
      message: ['', Validators.required],
      type: ['', Validators.required],
      due_date: [this.current_date,],
      body: ['',],
      time: [this.time,],
      budget: [this.budget_val,],
    });

    
    this.getTaskStatusList()
     
    this.getTaskPriorityList()
    this.activeEmployeeTab('current')
    this.getAllEmployee()
    this.getTaskLabelList()
    this.getEmployeeCategory()
    this.getAllStudents()
    this.getAllBatch()
    this.getTaskPriorityList()
  }
    getTaskStatusList() {
    this.apiService.getTagByTagCatgoryId(this.task_status_cat_id).subscribe((res: any) => {
      this.task_status_list = res.data
      
    })
  }
 
  activeEmployeeTab(tab) {
    const activetab = tab;
    this.activeTab = tab
    if (activetab !== '') {
      this.route.navigate(
        [],
        { relativeTo: this.activerouter, queryParams: { status: activetab } }
      );
    }
  }
  setAndGetTaskbyStatus() {
    this.activerouter.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        this.getTaskByStatusList()
      })
  }
 
 
    getTaskByStatusList(){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      let status = this.stage_list.find((item) => item.name == this.activeTab)
      this.apiService.getTaskByStage(status._id,1,100).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.spinner.hide()
            console.log(res)
            this.rows = res?.data?.items
            this.page.totalPages = res?.data?.totalCount
          }
        })  
    }
   pageChangeData(page: any) {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      let status = this.statusList.find((item) => item.name == this.activeTab);
      this.apiService.getEmployeeListByStatus(status._id,this.page.pageNumber + 1, this.limitRef).subscribe((res: any) => {
      this.rows = res.items
      this.page.totalPages = res.items.total
    })
  }
  filterTask(val) {
    this.apiService.taskSearch(val).subscribe((res: any) => {
      console.log(res)
      this.rows =res?.data?.items
     })
  }
  resetFilter(){
    this.inputName.nativeElement.value = null;
    this.setAndGetTaskbyStatus()
  }
 
  deleteEmployee(password) {
    this.apiService.deleteEmployee(this.employee_id,password).subscribe((res: any) => {
      if(res.statusCode === 200){
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.setAndGetTaskbyStatus()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    })
  }

  // ================== Delete Alert ========================
   // ================== Delete Alert ========================
   Delete(id: any) {
    this.employee_id = id
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteEmployee(result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  getAllEmployee() {
        this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.empList = res.items
          }
        })
      }
getTaskPriorityList() {
        this.apiService.getTagByTagCatgoryId(this.task_priority_catId).subscribe((res: any) => {
          this.task_priority_List = res.data
          
        })
      }
      getChangeTaskPriority(id) {
        this.selected_task_priority = id
      }
 getTaskStageList() {
        this.apiService.getTagByTagCatgoryId(this.task_stage_cat_id).subscribe((res: any) => {
          this.task_stage_list = res.data
          this.stage_list = res.data
          this.setAndGetTaskbyStatus()
          // let data ={displayname:'All',_id:'all'}
          // this.task_stage_list.push(data)
          // let dd = res.data
          // this.stage_list = dd.filter(item=> item.displayname !=='All')
        })
 }
    getCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = this.padNumber(today.getMonth() + 1);
    const day = this.padNumber(today.getDate());
    return `${year}-${month}-${day}`;
  }
  padNumber(number: number): string {
    return number < 10 ? `0${number}` : `${number}`;
  }
   getChangeTypeId(event) {
    this.selectedType
    if (event.name == 'Projects') {
      this.isProjectList = true
      this.isCheckList = false
      this.isLeadType = false
      this.getProjectList()
    }
    if (event.name == 'Checklist') {
      this.isCheckList = true
      this.isLeadType = false
      this.isProjectList = false
      this.getCheckList()
    }
    if (event.name == 'Leads') {
      this.isLeadType = true
      this.isProjectList = false
      this.isCheckList = false
    }
  }
  getProjectList() {
    this.apiService.getJobsByStatus('6428038677a2ab2fb559dc36', 1, 100, '', 'current').subscribe((res: any) => {
      this.project_list = res.data.items
    })
  }
  getProjectId(event) {
    this.select_project
    console.log('this.select_project', this.select_project)
  }
  getCheckList() {
    this.apiService.getAllChecklist(1, 100,'').subscribe((res: any) => {
      this.check_list = res.data.items
    })
  }
  getCheckListId(event) {
    this.select_checklist
    console.log('select_checklist', this.select_checklist)
  }
  getLeadTypeId(event) {
    this.select_leadType
    if (event.name === 'Training') {
      this.isTrainingLead = true
      this.getTrainingLead()
    }
    if (event.name === 'Outsource') {
      this.isOutsourceLead = true
      this.getOutsourceLead()
    }
  }
  getTrainingLead() {
    this.apiService.getLeadsByTagId(1, 100, '63e39db72052e0098e18e00e', '63e396fe2052e0098e18def3', 'active').subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.training_list = res.items
        console.log('tr', res)
      }
    })
  }
  getTrainingLeadId(event) {
    this.select_training_lead
  }
  getOutsourceLead() {
    this.apiService.getOutsourceLeadsByTagId(1, 100, '63e396de2052e0098e18deec', '63e39dd62052e0098e18e015','').subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.outsource_list = res.items
      }
    })
  }
  getOutsourceLeadId(event) {
    this.select_outsource_lead
  }
   getAllStudents() {
    this.apiService.getAllStudents(1, 100).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.studentList = res.items
      }
    })
  }
  getAllBatch() {
    this.apiService.getBatchList(1, 100).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.batchList = res.data.items
      }
    })
  }
  getEmployeeCategory() {
    this.apiService.getTagByTagCatgoryId(this.teamId).subscribe((res: any) => {
      this.teamList = res.data
    })
  }
 openModalUpdate(content, id, row_data, prop) {
    this.update_row_data = row_data
    console.log('not', this.update_row_data)
    if (row_data == null) {
      this.isReadOnly = true
    }
    else this.isReadOnly = false
    this.row_id = id
    this.row_prop = prop
    const modalOptions: NgbModalOptions = {
      size: 'lg' // 'sm', 'lg', or 'xl'
    };
      const modalRef = this.modalService.open(content,modalOptions);
      
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
        console.log(result)
      }, (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
  }
  inlineEditing(data) {
    this.update_row_data = data
  }
  submitEditData() {
        if(this.row_prop =='admin_notes'){
          let body ={
            admin_notes: this.update_row_data
          }
          this.apiService.updateTask(this.row_id,body).subscribe((res:any)=>{
            if(res?.statusCode === 200){
              this.toastr.success('update successfully')
              this.isEditor = false
              this.update_row_data =''
              this.modalService.dismissAll()
              this.setAndGetTaskbyStatus()
            }
            else{
              this.toastr.error(res.error)
            }
          })
        }
        if(this.row_prop =='notes'){
        let body ={
          notes: this.update_row_data
          }
          
        this.apiService.updateTask(this.row_id,body).subscribe((res:any)=>{
          if(res?.statusCode === 200){
            this.isReadOnly= true
            this.toastr.success('update successfully')
            this.update_row_data =''
            this.modalService.dismissAll()
              this.setAndGetTaskbyStatus()
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
      else if(this.row_prop =='body'){
        let body ={
          body: this.update_row_data
          }
        this.apiService.updateTask(this.row_id,body).subscribe((res:any)=>{
          if(res?.statusCode === 200){
            this.isReadOnly= true
            this.toastr.success('update successfully')
            this.update_row_data =''
            this.modalService.dismissAll()
              this.setAndGetTaskbyStatus()
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }

  }
  updatePrority(taskId,priorityId){
        let body ={
          priority : priorityId,
        }
        this.apiService.updateTask(taskId,body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('update successfully')
            this.setAndGetTaskbyStatus()
          }
          else{
            this.toastr.error(res.error)
          }
        })
      }
   updateStage(id, stage_id) {
    this.row_id =id
    let body = {
      stage : stage_id
    }
     this.apiService.updateTask(this.row_id,body).subscribe((res:any)=>{
          if(res?.statusCode === 200){
            this.toastr.success('update successfully')
            this.modalService.dismissAll()
              this.setAndGetTaskbyStatus()
          }
          else{
            this.toastr.error(res.error)
          }
        })
   }
  updateStatus(taskId,statusId){
      let body ={
        status :  statusId
      }
      this.apiService.updateTask(taskId,body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('update successfully')
          this.setAndGetTaskbyStatus()

        }
        else{
          this.toastr.error(res.error)
        }
      })

  }
   ConfirmDelete(id: any,i) {
        swal.fire({
          title: 'Are you sure?',
          text: `You won't be able to revert this!`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2F8BE6',
          cancelButtonColor: '#F55252',
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-warning',
            cancelButton: 'btn btn-danger ml-1'
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            this.deleteTracker(id,i)
          } else if (result.dismiss === swal.DismissReason.cancel) {
            swal.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          }
        });
      }
      deleteTracker(id,i){
        if (id) {
          this.apiService.taskDelete(id).subscribe((res: any) => {
            if (res.statusCode === 200) {              
              swal.fire({
                icon: "success",
                title: 'Deleted!',
                text: 'Your imaginary file has been deleted.',
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
              this.setAndGetTaskbyStatus()
            }
            else {
              // this.toastr.error(res.error)
              swal.fire({
                title: 'Error',
                text: res.error,
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-success'
                },
              })
            }
          })
        }
        else {
          // this.toastr.error('something went wrong !!')
          swal.fire({
            title: 'Error',
            text: 'something went wrong !!',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      }
   openModalAddTask(content,) {
    this.myForm.reset()

      this.select_project =null
      this.select_checklist =null
      this.select_training_lead =null
      this.select_outsource_lead =null
      this.selectedStudent = null
     
      const modalRef = this.modalService.open(content);

    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
   }

  
   createTask() {
  
      let body = {
        title: this.myForm.value.title,
        body: this.myForm.value.body,
        due_date: this.myForm.value.due_date,
        working_hours: this.myForm.value.time,
        budget: this.myForm.value.budget,
        // type : '63e39db72052e0098e18e00e',
        type_projects: this.select_project,
        type_checklist: this.select_checklist,
        type_training: this.select_training_lead,
        type_outsource: this.select_outsource_lead,
        to: this.selectedStudent,
        priority: this.selected_task_priority,
        label: this.selectedTaskLabel,
        is_schedule: this.selectedSchedule,
        is_mandatory: this.selectedMandatory,
        stage: '64ae445ee0a6ff2e7db78317',
        status: '643e869259b78b65557d755a'
      }
      if (this.selectedStudent?.length > 0) {
        body.to = this.selectedStudent
      }
      if (this.selectedBatch?.length > 0) {
        body.to = this.batch_selected_list_data
      }
      if (this.selectedEmp?.length > 0) {
        body.to = this.selectedEmp
      }
      if (this.selectTeam?.length > 0) {
        body.to = this.team_selected_list_data
      }
      // console.log('form val',body)
      this.apiService.createTask(body).subscribe((res: any) => {
        if (res.statusCode === 200) {
          this.toastr.success(res.message)
          this.modalService.dismissAll()
          this.setAndGetTaskbyStatus()
  
        }
        else {
          this.toastr.error(res.error)
        }
      })
  
   }
    // --------------- Student ------------------------------------------------------------------
   toggleAllSelectionStudent() {
    this.selectedStudent = [];
    this.isAllSelected = !this.isAllSelected;
    this.studentList.forEach((item, index) => {
      item.selected = this.isAllSelected;
      if (this.isAllSelected) {
        this.selectedStudent.push(item.id);
      }
      // Update the selected item count
      if (index < 5) {
        this.selectedItemCount = this.isAllSelected ? 5 : 0;
      } else if (index === 5) {
        this.selectedItemCount = this.isAllSelected ? 5 : 0;
      }
    });
  }
  toggleSelectionStudent(item) {
    if (item.selected) {
      this.selectedEmp.push(item.id);
    } else {
      const index = this.selectedStudent.findIndex((selectedItem) => selectedItem === item);
      if (index !== -1) {
        this.selectedStudent.splice(index, 1);
      }
    }
    this.isAllSelected = this.studentList.every((emp) => emp.selected);
  }
  onDropdownOpenStudent() {
    this.isAllSelected = this.studentList.every((item) => item.selected);
  }

  onDropdownCloseStudent() {
    this.isAllSelected = this.studentList.every((item) => item.selected);
  }
    // --------------- Team ------------------------------------------------------------------

    toggleAllSelectionTeam() {
      this.selectTeam = [];
      this.isAllSelected = !this.isAllSelected;
      this.teamList.forEach((item) => {
        item.selected = this.isAllSelected;
        if (this.isAllSelected) {
          this.selectTeam.push(item);
        }
      });
    }
  
    toggleSelectionTeam(item) {
      if (item.selected) {
        this.selectTeam.push(item);
        if (item != '') {
          this.apiService.getEmployeeByTeamId(item._id, 1, 100).subscribe((res: any) => {
            if (res.statusCode === 200) {
              this.isTeam_selected_list = true
              let data = res.items
              for (let item of data) {
                this.team_selected_list.push(item.user[0])
              }
              this.team_selected_list_data = this.team_selected_list.map(item => item._id)
            }
          })
        }
  
      } else {
        const index = this.selectTeam.findIndex((selectedItem) => selectedItem === item);
        if (index !== -1) {
          this.selectTeam.splice(index, 1);
        }
      }
      this.isAllSelected = this.teamList.every((team) => team.selected);
    }
  
    onDropdownOpenTeam() {
      this.isAllSelected = this.teamList.every((item) => item.selected);
    }
  
    onDropdownCloseTeam() {
      this.isAllSelected = this.teamList.every((item) => item.selected);
    }
    // --------------- Employee ------------------------------------------------------------------
    toggleAllSelectionEmp() {
      this.selectedEmp = [];
      this.isAllSelected = !this.isAllSelected;
      this.empList.forEach((item) => {
        item.selected = this.isAllSelected;
        if (this.isAllSelected) {
          this.selectedEmp.push(item._id);
        }
      });
      console.log('all emp', this.selectedEmp)
    }
  
    toggleSelectionEmp(item) {
      if (item.selected) {
        this.selectedEmp.push(item._id);
      } else {
        const index = this.selectedEmp.findIndex((selectedItem) => selectedItem === item);
        if (index !== -1) {
          this.selectedEmp.splice(index, 1);
        }
      }
      this.isAllSelected = this.empList.every((emp) => emp.selected);
    }
  
    onDropdownOpenEmp() {
      this.isAllSelected = this.empList.every((item) => item.selected);
    }
  
    onDropdownCloseEmp() {
      this.isAllSelected = this.empList.every((item) => item.selected);
    }
    // --------------- Batch ------------------------------------------------------------------
    toggleAllSelectionBatch() {
      this.selectedBatch = [];
      this.isAllSelected = !this.isAllSelected;
      this.batchList.forEach((item) => {
        item.selected = this.isAllSelected;
        if (this.isAllSelected) {
          this.selectedBatch.push(item);
        }
      });
    }
  
    toggleSelectionBatch(item) {
      if (item.selected) {
        this.selectedBatch.push(item);
        if (item._id != '') {
          this.apiService.getEnrolmentsByBatchId(item._id,'').subscribe((res: any) => {
            if (res.statusCode === 200) {
              this.isBatch_selected_list = true
              this.batch_selected_list = res.data
              // for(let item of data){
              //   this.batch_selected_list.push(item.user[0])
              // }
              this.batch_selected_list_data = this.batch_selected_list.map(item => item._id)
            }
          })
        }
  
      } else {
        const index = this.selectedBatch.findIndex((selectedItem) => selectedItem === item);
        if (index !== -1) {
          this.selectedBatch.splice(index, 1);
        }
      }
      this.isAllSelected = this.batchList.every((batch) => batch.selected);
    }
  
    onDropdownOpenBatch() {
      this.isAllSelected = this.batchList.every((item) => item.selected);
    }
  
    onDropdownCloseBatch() {
      this.isAllSelected = this.batchList.every((item) => item.selected);
    }
    onMenuItemClick(item: string) {
      console.log('Clicked:', item);
      // Add your custom logic here
    }
    getTaskLabelList() {
      this.apiService.getTagByTagCatgoryId(this.task_label_catId).subscribe((res: any) => {
        this.taskLabelList = res.data
      })
    }
    getChangeTaskLabelId(id) {
      this.selectedTaskLabel = id
    }
  
    getChangeScheduleId(id) {
      this.selectedSchedule = id
    }
    getChangeMandatoryId(id) {
      this.selectedMandatory = id
  
    }
   toggleActive(selected_item) {
      if (selected_item === 'emp-ind') {
        this.isEmpList = true;
        this.isTeamList = false
        this.isStudentList = false;
        this.isBatchList = false
      }
      else if (selected_item === 'emp-team') {
        this.isTeamList = true
        this.isEmpList = false;
        this.isStudentList = false;
        this.isBatchList = false
      }
      else if (selected_item === 'student-ind') {
        this.isStudentList = true;
        this.isBatchList = false
        this.isTeamList = false
        this.isEmpList = false;
  
      }
      else if (selected_item === 'student-batch') {
        this.isBatchList = true
        this.isStudentList = false;
        this.isTeamList = false
        this.isEmpList = false;
      }
    }
    toggleActiveStudent(name) {
      if (name === 'emp') {
        this.task_for_selected = 'employee'
        this.isEmployee = true;
        this.isEmpList = true
        this.isStudent = false;
        this.isStudentList = false
      }
      if (name === 'student') {
        this.task_for_selected = 'student'
        this.isStudent = true;
        this.isStudentList = true
        this.isEmpList = false
        this.isEmployee = false;
        this.isTeamList = false;
  
      }
    }
  inlineAddupdateBody(data, prop) {
      this.task_model.body =data
   }
       taskEdit(content,id){
        this.isAddNewTask = true
        this.task_id = id

        const modalRef = this.modalService.open(content);
      
          modalRef.result.then((result) => {
            // console.log(`Modal closed with result: ${result}`);
          }, (reason) => {
            // console.log(`Modal dismissed with reason: ${reason}`);
          });

        this.apiService.getTaskById(id).subscribe((res:any)=>{
          console.log(res)

          this.task_model.admin_notes = res?.data[0]?.admin_notes
          this.task_model.notes = res?.data[0]?.notes
          this.task_model.title = res?.data[0]?.title
          this.task_model.body = res?.data[0]?.body
          this.task_model.budget = res?.data[0]?.budget
          this.task_model.working_hours = res?.data[0]?.working_hours
          this.selectedEmp =  res?.data[0]?.to?.map(item => item._id)
          this.task_model.to = this.selectedEmp

          this.task_model.priority = res?.data[0]?.priority?._id
          this.task_model.stage  =  res?.data[0]?.stage?._id
          this.task_model.status  =  res?.data[0]?.status?.map(item=>item._id)
          this.task_model.due_date  =  res?.data[0]?.scheduleduration
          this.task_model.due_date = res?.data[0]?.due_date
          this.selectedSchedule  =  res?.data[0]?.is_schedule
          this.task_model.is_schedule =  this.selectedSchedule
          this.task_model.is_mandatory = res?.data[0]?.is_mandatory
          this.selected_task_label = res?.data[0]?.label?._id
          this.task_model.label  =  this.selected_task_label
         
        })
      }
      submit(){
        this.task_model.to = this.selectedEmp
        this.task_model.label  =  this.selected_task_label=='all'||this.selected_task_label=='All'?[]:this.selected_task_label
        this.task_model.is_schedule = this.selectedSchedule

        this.apiService.updateTask(this.task_id,this.task_model).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toastr.success('update successfull')
            this.selectedEmp = null
            this.selected_task_label = null
            this.task_id = ''
            this.myForm.reset()
            this.modalService.dismissAll()
            this.setAndGetTaskbyStatus()
          }
          else this.toastr.error(res.error)
        })
  }

  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  
}

